import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Record_component_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="record_component_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Component Overview</h2>
              <p>
                Record components are designed for users to view and edit data
                on an individual record. Because Nexoid uses a schema-less
                database structure, these record components act as the data
                schema controlling the shape and structure of records. Record
                pages have the most support for other types of components. It is
                possible to put a report or even search for a different type of
                record on a Record page.
              </p>
              <p>
                For more information, look at Search Components and Report
                Components in this documentation.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Record_component_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Record_component_overview.js